import React from "react";
import { Routes, Route } from "react-router-dom";
import AgentsListing from "./agentListing";
import AgentRosterDetails from "./agentDetails";
import AgentMap from "./agentMap"

const AgentRoster = () => {
  return (
    <Routes>
      <Route path="/:id/*" element={<AgentRosterDetails />} />
      <Route path="/" element={<AgentsListing />} />
      <Route path="/map" element={<AgentMap />} />
    </Routes>
  );
};
export default AgentRoster;